import { InaccessibleProperty } from "@opendaw/lib-std";
const getPropertyValue = (() => {
    if (typeof document === "undefined") {
        // This will compile in React but fails at runtime when no document is available
        return (_property) => InaccessibleProperty;
    }
    const computedStyle = getComputedStyle(document.documentElement);
    return (property) => computedStyle.getPropertyValue(property);
})();
export const Colors = {
    blue: getPropertyValue("--color-blue"),
    green: getPropertyValue("--color-green"),
    yellow: getPropertyValue("--color-yellow"),
    cream: getPropertyValue("--color-cream"),
    orange: getPropertyValue("--color-orange"),
    red: getPropertyValue("--color-red"),
    purple: getPropertyValue("--color-purple"),
    bright: getPropertyValue("--color-bright"),
    gray: getPropertyValue("--color-gray"),
    dark: getPropertyValue("--color-dark"),
    shadow: getPropertyValue("--color-shadow"),
    black: getPropertyValue("--color-black")
};
